export const config = {
  maxRounds: 7,
  coinMultiplier: 10,
  situationDuration: 20,
  optionDuration: 20,
  answerDuration: 15,
  RUDDERSTACK_ID: "2HWzlWZSOsGfBNNhzQwBJanpVpZ",
  RUDDERSTACK_DATAPLANE_URL: "https://zupayarpiamat.dataplane.rudderstack.com",
  URLS: {
    ADD_COINS_URL:
      "https://rewards.stag.apis.zupay.in/reward/process_reward_trans",
    FETCH_GAME: `${process.env.REACT_APP_API_ROOT_URL}/zp_games/`,
    // FETCH_GAME: `https://za-community.api.zupay.in/zp_games/`,
  },
  BACKEND_USERNAME: "dev",
  API_KEY: "vac301g2006bdfa0d49f",
};
